"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useQuery = require("./useQuery");
Object.keys(_useQuery).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useQuery[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useQuery[key];
    }
  });
});